//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SpecialictCard from "~/pages/specialists/components/SpecialistCard.vue";
import InfoAboutSpecialist from "~/components/appointment/InfoAboutSpecialist.vue";
export default {
  name: "SpecialistSelection",
  data: function () {
    return {
      search: "",
      about: [],
      specialists: null,
      isLoading: true,
    };
  },
  components: {
    SpecialictCard,
    InfoAboutSpecialist,
  },
  props: {
    activeAge: {
      type: String,
      required: true,
    },
    activeServce: {
      type: Number,
      required: true,
    },
    activeSalon: {
      type: [String, Number],
    },
    activeSpecialist: {
      type: Number,
    },
  },
  methods: {
    onSelect: function (service) {
      this.$emit("change", { name: "specialist", value: service.id });
    },
    onChangeSearch: function (event) {
      this.search = event.target.value;
    },
    onAbout: function (about) {
      this.about.push(about);
      this.$modal.show("special-modal-select");
    },
    onClose() {
      this.about = [];
    },

    getSpecialization: function(specialist) {
      return specialist?.position || ''
    }
  },
  async mounted() {
    const filterAge = Boolean(this.activeAge === "19") ? "filter[for_not_children]=1" : `filter[for_children_${(this.activeAge || "").replace("-", "_")}]=1`;
    const search = `${ filterAge }&filter[service_id]=${this.activeServce}${ Boolean(this.activeSalon === -1) ? '' : `&filter[store_id]=${this.activeSalon}` }`;
    const action = Boolean(this.activeSalon === -1) ? '/specialist' : '/specialist/available';

    let { data: specialists } = await this.$api.agent.transport.get(`${ action }?expand=stores&${ search }`);
    this.specialists = specialists;
    this.isLoading = false;
  },
};
